const PageTitle = ({ children }) => (
  <h1 className="text-224E73 text-2xl font-montserrat py-2 pt-0 font-medium">
    {children}
  </h1>
);

export default PageTitle;
